module.exports = __webpack_public_path__ + "img/hero-image-01-fi.90a4a974.png";